import React from 'react';
import TuvaModal from '@tuva-ui/components/src/TuvaModal';

const modalStyle = {
  top: '20px',
  width: '700px',
  padding: 0,
  transform: 'translateX(-50%)',
  maxHeight: 'calc(100vh - 40px)',
};

function CommitmentAccessModal({ onCancel }) {
  return (
    <TuvaModal
      isOpen
      onClose={onCancel}
      closeIcon
      style={modalStyle}
      className="tuva-common-modal"
    >
      <div className="popup-header border-bottom py-3 px-4">
        <h5 className="font-bold">Our Commitment to Access and Equity</h5>
      </div>
      <div className="py-4 px-4 text-gray-600 text-base">
        <p className="mb-3">
          We believe every student should get the opportunity to develop the
          data literacy skills they need for life and career. To make that
          vision a reality, we have committed to making the Tuva data tools
          freely available and accessible for learners with diverse cognitive
          and physical abilities.
        </p>
        <p>
          <b>To learn more about Tuva,</b> read{' '}
          <a target="_blank" rel="noreferrer" href="/about/">
            About Us
          </a>{' '}
          and{' '}
          <a
            target="_blank"
            rel="noreferrer"
            href="https://support.tuvalabs.com/hc/en-us/categories/360004269434-Accessibility-of-Tuva-Tools"
          >
            Our Commitment to Accessibility.
          </a>
        </p>
      </div>
    </TuvaModal>
  );
}

export default CommitmentAccessModal;
